// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const diagnosisCategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDiagnosisCategories: builder.query({
      query: filter => {
        const qs = new URLSearchParams(filter).toString();
        return 'diagnosis_category' + (qs ? '?' + qs : '');
      },
      providesTags: ['DiagnosisCategory'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetDiagnosisCategoriesQuery,
} = diagnosisCategoryApi;
